import { render, staticRenderFns } from "./WabaActivityCard.vue?vue&type=template&id=3b9451d5&scoped=true"
import script from "./WabaActivityCard.vue?vue&type=script&lang=js"
export * from "./WabaActivityCard.vue?vue&type=script&lang=js"
import style0 from "./WabaActivityCard.vue?vue&type=style&index=0&id=3b9451d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9451d5",
  null
  
)

export default component.exports